import axios from '@/libs/api.request'

/**
 * 在线沟通模块 API
 * 企业端（user_type=2）与求职者（user_type=1）进行在线交流
 */

/**
 * 获取会话列表
 * @param {Object} params - 查询参数
 * @param {Number} params.page - 页码，默认1
 * @param {Number} params.page_size - 每页数量，默认20
 * @param {Number} params.chat_type - 会话类型 (1=职位沟通, 2=简历沟通), 可选
 * @returns {Promise}
 */
export const getChatSessions = (params) => {
  return axios.request({
    url: '/v1/chat/sessions',
    method: 'get',
    params: params
  })
}

/**
 * 获取会话详情
 * @param {Number} sessionId - 会话ID
 * @returns {Promise}
 */
export const getChatSessionDetail = (sessionId) => {
  return axios.request({
    url: `/v1/chat/sessions/${sessionId}`,
    method: 'get'
  })
}

/**
 * 获取历史消息列表
 * @param {Object} params - 查询参数
 * @param {Number} params.session_id - 会话ID
 * @param {Number} params.page - 页码，默认1
 * @param {Number} params.page_size - 每页数量，默认30
 * @returns {Promise}
 */
export const getChatMessages = (params) => {
  return axios.request({
    url: '/v1/chat/messages',
    method: 'get',
    params: params
  })
}

/**
 * 发送消息
 * @param {Object} data - 消息数据
 * @param {Number} data.session_id - 会话ID
 * @param {Number} data.message_type - 消息类型 (1=文本, 2=图片, 3=系统消息)
 * @param {String} data.content - 消息内容
 * @param {String} data.image_url - 图片URL (message_type=2时必填)
 * @returns {Promise}
 */
export const sendChatMessage = (data) => {
  return axios.request({
    url: '/v1/chat/message',
    method: 'post',
    data: data
  })
}

/**
 * 标记消息已读
 * @param {Object} data - 请求数据
 * @param {Number} data.session_id - 会话ID
 * @returns {Promise}
 */
export const markMessagesRead = (data) => {
  return axios.request({
    url: '/v1/chat/read',
    method: 'post',
    data: data
  })
}

/**
 * 获取未读消息总数
 * @returns {Promise}
 */
export const getUnreadCount = () => {
  return axios.request({
    url: '/v1/chat/unread_count',
    method: 'get'
  })
}

/**
 * 创建会话（企业主动发起）
 * @param {Object} data - 会话数据
 * @param {Number} data.target_user_id - 目标用户ID（求职者ID）
 * @param {Number} data.chat_type - 会话类型 (1=职位沟通, 2=简历沟通)
 * @param {Number} data.related_id - 关联ID（职位ID或简历ID）
 * @returns {Promise}
 */
export const createChatSession = (data) => {
  return axios.request({
    url: '/v1/chat/session',
    method: 'post',
    data: data
  })
}

/**
 * 上传图片
 * @param {FormData} formData - 包含图片文件的 FormData
 * @returns {Promise}
 */
export const uploadChatImage = (formData) => {
  return axios.request({
    url: '/v1/chat/upload_image',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
